import script from "./ListColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListColumn.vue?vue&type=script&setup=true&lang=ts"

import "./ListColumn.vue?vue&type=style&index=0&id=5666d6ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5666d6ae"]])

export default __exports__